import { NgModule } from '@angular/core';
import { TravellerService } from './traveller.service';
@NgModule({
    providers: [
        TravellerService,
    ]
})
export class TravellerModule {  }